import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Divider,
  Descriptions,
  Table,
  Typography,
  Space,
} from 'antd';

import { get } from '../../../api/modules/answers';
import INTERNAL_LINKS from '../../../enum/InternalLinks';

const { Title } = Typography;

const PollHomePage = ({ match, location }) => {
  const columns = [
    {
      title: '',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Chapter / Capitulo',
      dataIndex: 'chapter',
      key: 'chapter',
    },
    {
      title: 'Status / Estado',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        switch (text) {
          case null:
            return "Empty / Sin diligenciar";
          case 0:
            return "In progress / En proceso";
          case 1:
            return "Closed (unfinished) / Cerrado (parcial)";
          case 2:
            return "Closed / Cerrado";
          default:
            return null;
        }
      }
    },
    {
      title: 'Actions / Acciones',
      dataIndex: 'url',
      key: 'url',
      render: (text, record) => {
        return (<Space>
          <Button type="primary"><Link to={`${text}/${match.params.id}/en`}>Edit</Link></Button>
          <Button type="primary"><Link to={`${text}/${match.params.id}/es`}>Editar</Link></Button>
        </Space>);
      }
    },
  ];
  const [answerData, setAnswerData] = useState({});
  let [dataSource, setDataSource] = useState([]);
  let [loading, setloading] = useState(false);
  let [pollStatus, setPollStatus] = useState(false);

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = async () => {
    await getAnswer();
  };

  const getAnswer = async () => {
    setloading(true);
    const response = await get(match.params.id);


    setPollStatus(response.data.status_i === 2 && response.data.status_ii === 2 && response.data.status_iii === 2 && response.data.status_iv === 2 && response.data.status_v === 2);
    setAnswerData(response.data);
    setDataSource([
      {
        id: "I",
        chapter: "CHARACTERISTICS OF THE INFORMANT / CARACTERÍSTICAS DEL INFORMANTE",
        status: response.data.status_i,
        url: INTERNAL_LINKS.POLL_CHAPTER_I
      },
      {
        id: "II",
        chapter: "GENERALITIES / GENERALIDADES",
        status: response.data.status_ii,
        url: INTERNAL_LINKS.POLL_CHAPTER_II
      },
      {
        id: "III",
        chapter: "CHARACTERIZATION OF THE NEEDS OF MIGRANTS, REFUGEES AND THEIR HOST COMMUNITIES / CARACTERIZACIÓN DE NECESIDADES DE PERSONAS MIGRANTES, REFUGIADAS Y SUS COMUNIDADES DE ACOGIDA",
        status: response.data.status_iii,
        url: INTERNAL_LINKS.POLL_CHAPTER_III
      },
      {
        id: "IV",
        chapter: "INSTITUTIONALITY AND PARTICIPATION OF MIGRANTS AND REFUGEES / INSTITUCIONALIDAD Y PARTICIPACIÓN DE LAS PERSONAS MIGRANTES AND REFUGEES",
        status: response.data.status_iv,
        url: INTERNAL_LINKS.POLL_CHAPTER_IV
      },
      {
        id: "V",
        chapter: "DEVELOPMENT OF PUBLIC POLICIES AND GOOD PRACTICES / DESARROLLO DE POLÍTICAS PÚBLICAS Y BUENAS PRÁCTICAS",
        status: response.data.status_v,
        url: INTERNAL_LINKS.POLL_CHAPTER_V
      },
    ]);
    setloading(false);
  };

  return (<div>
    <Title level={3}>Edit form / Formulario de edición</Title>
    <Space direction={'vertical'}>
      <Divider>Element information / Información del elemento</Divider>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Country / País">{answerData.country}</Descriptions.Item>
        {answerData.level === "a11e9b76-fe24-4825-ba4f-e3f18d65a528" &&
          <Descriptions.Item label="City / Ciudad">{answerData.city}</Descriptions.Item>
        }
        {answerData.level === "19d2f9ce-4501-4625-b18b-358ef9be2f07" &&
          <Descriptions.Item label="Other / Otro">{answerData.other}</Descriptions.Item>
        }
        <Descriptions.Item label="Name / Nombre">{answerData.q1_c}</Descriptions.Item>
      </Descriptions>
      <Divider>Survey information / Información de la encuesta</Divider>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Status / Estado">{pollStatus ? 'Finished / Terminada' : 'In progress / En proceso'}</Descriptions.Item>
      </Descriptions>
      <Divider>Chapter information / Información de los capitulos</Divider>
      <Table loading={loading} dataSource={dataSource} columns={columns} />
    </Space>
    <Button type="primary"><Link to={INTERNAL_LINKS.SURVEY_HOME}>Back / Volver</Link></Button>
  </div>);
};

export default PollHomePage;